<template>
<div class="xin">
    <!-- tab 切换  -->
    <div class="switch">
        <el-tabs >
            <!-- 隔离邮件通知设置 -->
            <el-tab-pane>
                <span slot="label"> {{ $t("logs.notifyman1") }}</span>
                <div class="lie">
                    <table>
                        <tbody>
                            <tr>
                                <!-- 隔离通知管理默认域名 -->

                                <td>{{ $t("logs.notify1") }}:</td>
                                <td >
                                    <el-input v-model="default_domain" placeholder=""></el-input>

                                    <el-alert :title="this.gl_dn_hint" type="warning" show-icon :closable="false">
                                    </el-alert>
                                </td>
                            </tr>
                            <tr>
                                <!-- 隔离网关web地址 -->

                                <td>{{ $t("logs.notify2") }}:</td>

                                <td >
                                    <el-input v-model="webaddr" placeholder=""></el-input>

                                    <el-alert :title="this.gl_webaddr_hint" type="warning" show-icon :closable="false">
                                    </el-alert>
                                </td>
                            </tr>
                            <tr>
                                <!-- 隔离定期发送点 -->
                                <td>{{ $t("logs.notify3") }}:</td>
                                <td >
                                    <el-input v-model="send_time" placeholder=""></el-input>

                                    <el-alert :title="this.send_time_hint" type="warning" show-icon :closable="false">
                                    </el-alert>
                                </td>
                            </tr>
                            <tr>
                                <!-- 隔离邮件链接有效天数 -->

                                <td>{{ $t("logs.notify4") }}:</td>
                                <td >
                                    <el-input v-model="save_days" placeholder=""></el-input>

                                    <el-alert :title="this.save_days_hint" type="warning" show-icon :closable="false">
                                    </el-alert>
                                </td>
                            </tr>
                            <tr>
                                <!-- 通知策略选项 -->

                                <td>{{ $t("logs.notify5") }}:</td>
                                <td >
                                    <el-select v-model="notify_options" placeholder="请选择" size="mini">
                                        <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
                                        </el-option>
                                    </el-select>
                                    <el-alert :title="this.gl_onoff_hint" type="warning" show-icon :closable="false">
                                    </el-alert>
                                    
                                </td>
                            </tr>
                            <tr>
                                <!-- 启用 -->

                                <td>{{ $t("logs.notify6") }}:</td>
                                <td style="display:flex;flex-direction:row">
                                    <el-checkbox-group v-model="onoff">
                                        <el-checkbox label=""></el-checkbox>
                                    </el-checkbox-group>
                                    <el-alert :title="$t('logs.notify_state6')" type="warning" show-icon :closable="false" style="margin-top:8px;margin-left:8px">
                                    </el-alert>
                                </td>
                            </tr>
                            <tr>
                                <td></td>
                                <td style="display:flex;flex-direction:row">
                                    <el-button type="primary" @click="save" :disabled="$root.jurisdiction.only_query==0">{{
                      $t("logs.save_a")
                    }}</el-button>
                                    <!-- <el-button  @click="tanSend()">{{ $t("logs.save_b") }}</el-button>-->
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </el-tab-pane>

            <!-- 排除账号列表 -->
            <el-tab-pane label="">
                <span slot="label"> {{ $t("logs.notifyman2") }}</span>
                <div class="main">
                 
                        <!-- 添加排除账号 -->

                        <el-button @click="tan()" :disabled="$root.jurisdiction.only_query==0">{{ $t("logs.notify10") }}</el-button>
                         <el-alert :title="this.show_hint1" type="warning" show-icon :closable="false">
                                    </el-alert>
                   
                </div>
                <div class="switch1">
                    <div class="table">
                        <el-table ref="multipleTable" tooltip-effect="dark" style="width: 100%" :data="fileList" v-loading="loading">
                            <el-table-column prop="RECSEQ" :label="$t('logs.xuhao')" width="70">
                            </el-table-column>
                            <el-table-column prop="DNOREMAIL" :label="$t('logs.notify7')">
                            </el-table-column>

                            <el-table-column prop="address" :label="$t('table1.operation')">
                                <template slot-scope="scope">
                                    <!-- 删除 -->
                                    <el-button @click="handleClick1(scope.$index, scope.row)" type="text" size="small" :disabled="$root.jurisdiction.only_query==0">{{ $t("table1.delete") }}</el-button>
                                </template>

                            </el-table-column>
                        </el-table>
                    </div>
                    <div class="pop-up" v-show="tanchu" v-drag="{ handle: '.pop_up_text_tls_address' }">
                        <!--  认证控制-->
                        <div class="pop_up_text pop_up_text_tls_address"><span class="span_pad"></span> {{$t('logs.notify10')}}</div>
                        <p></p>
                        <div class="find">
                          
                            <div class="find1">
                                <div class="find-text" style="padding-right:12px">
                                    <!-- 域名或邮箱账号 -->

                                    {{ $t("logs.notify7") }} :
                                </div>
                                <div class="block block1">
                                    <el-input v-model="dnoremail" placeholder=""></el-input>
                                </div>
                            </div>
                        </div>

                        <el-row>
                            <!-- 保存 -->

                            <el-button type="primary"  @click="save1()" :disabled="$root.jurisdiction.only_query==0">{{ $t("logs.save_a") }}</el-button>
                            <!-- 取消 -->

                            <el-button type="danger"  @click="tanOff()" :disabled="$root.jurisdiction.only_query==0">{{ $t("logs.save_b") }}</el-button>
                        </el-row>
                    </div>
                    <div class="gray" v-show="tanchu"></div>
                </div>
            </el-tab-pane>
            <!-- 指定账号列表 -->
            <el-tab-pane label="指定账号列表">
                <span slot="label"> {{ $t("logs.notifyman3") }}</span>
                <div class="main">
                   
                        <!-- 添加指定账号 -->

                        <el-button @click="tan()" :disabled="$root.jurisdiction.only_query==0">{{ $t("logs.notify11") }}</el-button>
                     <el-alert :title="this.show_hint2" type="warning" show-icon :closable="false">
                                    </el-alert>
                </div>
                <div class="switch1">
                    <div class="table">
                        <el-table ref="multipleTable" tooltip-effect="dark" style="width: 100%" :data="fileList2" v-loading="loading">
                            <el-table-column prop="RECSEQ" :label="$t('logs.xuhao')" width="70">
                            </el-table-column>
                            <el-table-column prop="DNOREMAIL" :label="$t('logs.notify7')">
                            </el-table-column>

                            <el-table-column prop="address" :label="$t('table1.operation')">
                                <template slot-scope="scope">
                                    <!-- 删除 -->
                                    <el-button @click="handleClick2(scope.$index, scope.row)" type="text" size="small" :disabled="$root.jurisdiction.only_query==0">{{ $t("table1.delete") }}</el-button>
                                </template>
                            </el-table-column>
                        </el-table>
                    </div>
                    <div class="pop-up" v-show="tanchu" v-drag ="{ handle: '.pop_up_text_ipcor' }">
                        <!--  认证控制-->
                        <div class="pop_up_text pop_up_text_ipcor"><span class="span_pad"></span> {{$t('logs.notify11')}}</div>
                        <p></p>
                        <div class="find">
                           
                            <div class="find1">
                                <div class="find-text" style="padding-right:12px">
                                    <!-- 域名或邮箱账号 -->

                                    {{ $t("logs.notify7") }} :
                                </div>
                                <div class="block block1">
                                    <el-input v-model="dnoremail" placeholder=""></el-input>
                                </div>
                            </div>
                        </div>

                        <el-row>
                            <el-button type="primary"  @click="save2()" :disabled="$root.jurisdiction.only_query == 0">{{ $t("logs.save_a") }}</el-button>
                            <el-button type="danger"  @click="tanOff()">{{ $t("logs.save_b") }}</el-button>
                        </el-row>
                    </div>
                    <div class="gray" v-show="tanchu"></div>
                </div>
            </el-tab-pane>
            <!--  -->
            <el-tab-pane label="别名账号列表">
                <span slot="label">{{ $t("logs.notifyman4") }}</span>
                <div class="main">
                   
                        <!-- 添加别名账号 -->

                        <el-button @click="tan()" :disabled="$root.jurisdiction.only_query==0">{{ $t("logs.notify12") }}</el-button>
                         <el-alert :title="this.show_hint3" type="warning" show-icon :closable="false">
                                    </el-alert>
                   
                </div>
                <div class="switch1">
                    <div class="table">
                        <el-table ref="multipleTable" tooltip-effect="dark" style="width: 100%" :data="fileList3" v-loading="loading">
                            <el-table-column prop="RECSEQ" :label="$t('logs.xuhao')" width="70">
                            </el-table-column>
                            <el-table-column prop="EMAIL" :label="$t('logs.notify8')">
                            </el-table-column>
                            <el-table-column prop="ALIAS" :label="$t('logs.notify9')">
                            </el-table-column>
                            <el-table-column prop="address" :label="$t('table1.operation')">
                                <template slot-scope="scope">
                                    <!-- 删除 -->
                                    <el-button @click="handleClick3(scope.$index, scope.row)" type="text" size="small" :disabled="$root.jurisdiction.only_query==0">{{ $t("table1.delete") }}</el-button>
                                    
                                </template>
                            </el-table-column>
                        </el-table>
                    </div>
                    <div class="pop-up" v-show="tanchu" v-drag="{ handle: '.pop_up_text_local_domain_edit' }">
                        <!--  认证控制-->
                        <div class="pop_up_text pop_up_text_local_domain_edit"><span class="span_pad"></span> {{$t('logs.notify12')}}</div>
                        <p></p>
                        <div class="find">
                           
                            <div class="find1">
                                <div class="find-text" style="padding-right:12px">
                                    {{ $t("logs.notify8") }}:
                                </div>
                                <div class="block block1">
                                    <el-input v-model="email" placeholder=""></el-input>
                                </div>
                            </div>
                            <div class="find1">
                                <div class="find-text" style="padding-right:12px">
                                    {{ $t("logs.notify9") }}:
                                </div>
                                <div class="block block1">
                                    <el-input v-model="alias" placeholder=""></el-input>
                                </div>
                            </div>
                        </div>

                        <el-row>
                            <el-button type="primary"  @click="save3()" :disabled="$root.jurisdiction.only_query == 0">{{ $t("logs.save_a") }}</el-button>
                            <el-button  type="danger"  @click="tanOff()">{{ $t("logs.save_b") }}</el-button>
                        </el-row>
                    </div>
                    <div class="gray" v-show="tanchu"></div>
                </div>
            </el-tab-pane>
             <!--  -->
            <el-tab-pane label="自定义隔离通知">
                <span slot="label">{{ $t("logs.notify13") }}</span>
                <div class="main">
                   
                        <!-- 自定义添加-->

                        <el-button @click="tan()" :disabled="$root.jurisdiction.only_query==0">{{ $t("logs.notify13_add") }}</el-button>
                         <el-alert :title="this.show_hint4" type="warning" show-icon :closable="false">
                                    </el-alert>
                   
                </div>
                <div class="switch1">
                    <div class="table">
                        <el-table ref="multipleTable" tooltip-effect="dark" style="width: 100%" :data="fileList4" v-loading="loading">
                            <el-table-column prop="RECSEQ" :label="$t('logs.xuhao')" width="70">
                            </el-table-column>
                            <el-table-column prop="EMAIL" :label="$t('logs.notify8')">
                            </el-table-column>
                            <el-table-column prop="SHOW_TYPE" :label="$t('logs.smtpIp6')" width="300">
                            </el-table-column>
                             <!-- <el-table-column prop="NOTICE_TIME" :label="$t('logs.notify13_notice_time')">
                            </el-table-column> -->
                            <el-table-column prop="address" :label="$t('table1.operation')" width="100">
                                <template slot-scope="scope">
                                    <!-- 删除 -->
                                    <el-button @click="handleClick4(scope.$index, scope.row)" type="text" size="small" :disabled="$root.jurisdiction.only_query==0">{{ $t("table1.delete") }}</el-button>
                                       <!-- 编辑-->
                                    <el-button @click="handleClick_edit(scope.$index, scope.row)" type="text" size="small" :disabled="$root.jurisdiction.only_query==0">{{ $t("table1.ditt") }}</el-button>
                                </template>
                            </el-table-column>
                        </el-table>
                    </div>
                    <div class="pop-up" v-show="tanchu" v-drag="{ handle: '.pop_up_text_url_w' }">
                        <!--  认证控制-->
                        <div class="pop_up_text pop_up_text_url_w"><span class="span_pad"></span><span v-if="this.custom_editing==1">{{$t('logs.notify13_add')}}</span><span v-if="this.custom_editing==0">{{$t('logs.notify13_edit')}}</span> </div>
                        <p></p>
                        <div class="find">
                           
                            <div class="find1">
                                <div class="find-text" style="padding-right:12px">
                                    {{ $t("logs.notify7") }}:
                                </div>
                                <div class="block block1">
                                    <el-input v-model="email" placeholder=""   clearable  v-if="this.custom_editing == 1"></el-input>
                                     <p
                      v-if="this.custom_editing == 0"
                      style="
                        text-align: left;
                        color: #0e2c5e;
                        margin: 8px 0px;
                        border-bottom: 0;
                      "
                    >
                      {{ this.email }}
                    </p>
                                </div>
                            </div>
                            <div class="find1">
                                <div class="find-text" style="padding-right:12px">
                                    {{ $t("logs.notify13_policy") }}:
                                </div>
                                <div class="block block1">
                                     <el-select v-model="notific_policy" placeholder="请选择">
    <el-option
      v-for="item in notific_policy_arr"
      :key="item.value"
      :label="item.label"
      :value="item.value">
    </el-option>
  </el-select>
                                  
                                </div>
                            </div>
                             <div class="find1">
                                <div class="find-text" style="padding-right:12px">
                                    {{ $t("logs.notify13_notice_time") }}:
                                </div>
                                <div class="block block1">
                                     <el-input v-model="notice_time" placeholder="用冒号隔开，如8:16,表示8点和16点发送"   clearable></el-input >
                                  
                                </div>
                            </div>
                        </div>

                        <el-row>
                            <el-button type="primary"  @click="save4()" :disabled="$root.jurisdiction.only_query == 0">{{ $t("logs.save_a") }}</el-button>
                            <el-button  type="danger"  @click="tanOff()">{{ $t("logs.save_b") }}</el-button>
                        </el-row>
                    </div>
                    <div class="gray" v-show="tanchu"></div>
                </div>
            </el-tab-pane>
        </el-tabs>
    </div>
</div>
</template>

<script>
// import $ from "jquery";
export default {
    data() {
        return {
            newadd:1,
            custom_editing:1,
            gl_dn_hint:'',
            gl_webaddr_hint:'',
            send_time_hint:'',
            save_days_hint:'',
            gl_onoff_hint:'',
            show_hint4:'',
            show_hint5:'',
            show_hint3:'',
            show_hint2:'',
            show_hint1:'',
            dnoremail: "",
            email: "",
            alias: "",
            notify_options: [],
            onoff: [],
            save_days: "",
            send_time: "",
            webaddr: "",
            default_domain: "",
            textarea: "",
            input: "",
            time: new Date(2020, 9, 10, 18, 40),
            value1: "",

            tableData: [{
                address: "44",
            }, ],
            emali: "",
            value: "",
            checkList: [],
            tanchu: false,
            options: [],
            checked: "",
            fileList: [],
            fileList1: [],
            fileList2: [],
            fileList3:[],
            fileList4:[],
            fileList5:[],
            radio: [],
            notific_policy_arr:[],
            notific_policy:'',
            notice_time:'',
            loading:false,
        };
    },
    mounted() {
        this.getFileList_inform();// 隔离
        this.getFileList_exclude();//排除
        this.getFileList_assign ();//指定
        this.getFileList_alias();//别名
        this.getFileList_notific();//自定义
    },
    methods: {
        // 渲染1
        getFileList_inform() {
            this.loading = true;

            let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
         
            // console.log(this)
            // 获取表单数据,搜索条件

            // console.log(col, '5555')

            this.$axios
                .get("/api/adm/cgi/newspam.cgi", {
                    params: {
                        __mode: "load_notify_spam",
                        sid: sid,

                        // screen: "real_filterlog.html",
                    },
                })
                .then((res) => {
                    // console.log(res);
                    // console.log(col, "传的col值");

                    // console.log(this.col1, "传的col1值");
                    // console.log(this.page, '222')
this.loading = false;
                    if(!res){
             this.loading = false;
          }
         else if (!res.data.fmstatus) {
                        alert(res.data);
                    } else if (res.data.fmstatus.code == "2") {
                        alert(res.data.fmstatus.errmsg);
                        this.loading =false
                    } else if (res.data.fmstatus.code == "3") {
                        alert(res.data.fmstatus.errmsg);
                        this.$router.push({
                            name: "login",
                        });
                    } else {
                        this.default_domain = res.data.ret.result.default_domain;
                        this.webaddr = res.data.ret.result.webaddr;
                        this.send_time = res.data.ret.result.send_time;
                        this.save_days = res.data.ret.result.save_days;
                        this.notify_options =( res.data.ret.result.options)/1;
                        this.options = res.data.ret.q_type;
                        this.gl_dn_hint=res.data.ret.gl_dn_hint
                        this.gl_webaddr_hint=res.data.ret.gl_webaddr_hint
                        this.send_time_hint=res.data.ret.send_time_hint
                        this.save_days_hint=res.data.ret.save_days_hint
                        this.gl_onoff_hint=res.data.ret.gl_onoff_hint
                        this.onoff =
                            res.data.ret.result.onoff == "0" ?
                            (this.onoff = false) :
                            (this.onoff = true);
                    }
                })
               
        },
        // 隔离邮件通知设置保存
        save() {
            let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
            console.log(sid);

            let default_domain = this.default_domain;

            let webaddr = this.webaddr;
            let send_time = this.send_time;
            let save_days = this.save_days;
            let notify_options = this.notify_options;
            let onoff = this.onoff == false ? (onoff = "0") : (onoff = "1");
            // console.log(col, '5555')

            this.$axios
                .get("/api/adm/cgi/newspam.cgi", {
                    params: {
                        __mode: "save_notify_spam",
                        sid: sid,
                        default_domain: default_domain,
                        webaddr: webaddr,
                        send_time: send_time,
                        save_days: save_days,
                        notify_options: notify_options,
                        onoff: onoff,
                    },
                })
                .then((res) => {
                    console.log(res);

                    if (!res.data.fmstatus) {
                        alert(res.data);
                    } else if (res.data.fmstatus.code == "1") {
                        alert(res.data.fmstatus.errmsg);
                    } else if (res.data.fmstatus.code == "2") {
                        alert(res.data.fmstatus.errmsg);
                       
                    } else if (res.data.fmstatus.code == "3") {
                        // alert(res.data.fmstatus.errmsg);
                        this.$router.push({
                            name: "login",
                        });
                    } else {
                        this.loading = false;
                        this.getFileList_inform();
                        this.$message({
                            type: "success",
                            message: `${this.$t("anti_gs1_tan.save_sueecss")}`,
                        });
                    }
                });
        },
        // 渲染2
        getFileList_exclude() {
            this.loading = true;

            let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
            

            this.$axios
                .get("/api/adm/cgi/newspam.cgi", {
                    params: {
                        __mode: "list_exclude_user",
                        sid: sid,
                    },
                })
                .then((res) => {
                    // console.log(res);
this.loading = false;
                    if(!res){
             this.loading = false;
          }
         else if (!res.data.fmstatus) {
                        alert(res.data);
                    } else if (res.data.fmstatus.code == "2") {
                        alert(res.data.fmstatus.errmsg);
                        this.loading=false
                    } else if (res.data.fmstatus.code == "3") {
                        // alert(res.data.fmstatus.errmsg);
                        this.$router.push({
                            name: "login",
                        });
                    } else {
                        this.fileList = res.data.ret.datalist;
                        this.show_hint1=res.data.ret.addexcludeuser_hint
                    }
                })
               
        },
        // 排除账号列表保存
        save1() {
            this.$save_hint_test();
            this.$disable_hint_test();
            let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
            console.log(sid);

            let dnoremail = this.dnoremail;

            // console.log(col, '5555')

            this.$axios
                .get("/api/adm/cgi/newspam.cgi", {
                    params: {
                        __mode: "save_exclude_user",
                        sid: sid,
                        dnoremail: dnoremail,

                    },
                })
                .then((res) => {
                    console.log(res);
this.$close_hint_test();
this.$close_disable_hint_test();
                    if (!res.data.fmstatus) {
                        alert(res.data);
                    } else if (res.data.fmstatus.code == "1") {
                        alert(res.data.fmstatus.errmsg);
                    } else if (res.data.fmstatus.code == "2") {
                        alert(res.data.fmstatus.errmsg);
                     
                    } else if (res.data.fmstatus.code == "3") {
                        // alert(res.data.fmstatus.errmsg);
                        this.$router.push({
                            name: "login",
                        });
                    } else {
                        this.tanchu = false;
                        this.loading = false;
                        this.getFileList_exclude();
                        this.$message({
                            type: "success",
                            message: `${this.$t("anti_gs1_tan.save_sueecss")}`,
                        });
                    }
                });
        },
        // 指定账号列表保存
        save2() {
            this.$save_hint_test();
            this.$disable_hint_test();
            let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
            console.log(sid);

            let dnoremail = this.dnoremail;

            // console.log(col, '5555')

            this.$axios
                .get("/api/adm/cgi/newspam.cgi", {
                    params: {
                        __mode: "save_appoint_user",
                        sid: sid,
                        dnoremail: dnoremail,

                    },
                })
                .then((res) => {
                    console.log(res);
this.$close_hint_test();
this.$close_disable_hint_test();
                    if (!res.data.fmstatus) {
                        alert(res.data);
                    } else if (res.data.fmstatus.code == "1") {
                        alert(res.data.fmstatus.errmsg);
                    } else if (res.data.fmstatus.code == "2") {
                        alert(res.data.fmstatus.errmsg);
                      
                    } else if (res.data.fmstatus.code == "3") {
                        // alert(res.data.fmstatus.errmsg);
                        this.$router.push({
                            name: "login",
                        });
                    } else {
                        this.tanchu = false;
                        this.loading = false;
                        this.getFileList_assign ();
                        this.$message({
                            type: "success",
                            message: `${this.$t("anti_gs1_tan.save_sueecss")}`,
                        });
                    }
                });
        },
        //别名账号列表保存
        save3() {
            this.$save_hint_test();
            this.$disable_hint_test();
            let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
            console.log(sid);

            let email = this.email;
            let alias = this.alias;

            // console.log(col, '5555')

            this.$axios
                .get("/api/adm/cgi/newspam.cgi", {
                    params: {
                        __mode: "save_alias_user",
                        sid: sid,
                        email: email,
                        alias: alias,

                    },
                })
                .then((res) => {
                    console.log(res);
this.$close_hint_test();
this.$close_disable_hint_test();
                    if (!res.data.fmstatus) {
                        alert(res.data);
                    } else if (res.data.fmstatus.code == "1") {
                        alert(res.data.fmstatus.errmsg);
                    } else if (res.data.fmstatus.code == "2") {
                        alert(res.data.fmstatus.errmsg);
                        
                    } else if (res.data.fmstatus.code == "3") {
                        // alert(res.data.fmstatus.errmsg);
                        this.$router.push({
                            name: "login",
                        });
                    } else {
                        this.tanchu = false;
                        this.loading = false;
                        this.getFileList_alias();
                        this.$message({
                            type: "success",
                            message: `${this.$t("anti_gs1_tan.save_sueecss")}`,
                        });
                    }
                });
        },
        // 渲染3   
        getFileList_assign () {
            this.loading = true;

            let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
          

            this.$axios
                .get("/api/adm/cgi/newspam.cgi", {
                    params: {
                        __mode: "list_appoint_user",
                        sid: sid,
                    },
                })
                .then((res) => {
                    // console.log(res);
this.loading = false;
                   if(!res){
             this.loading = false;
          }
         else  if (!res.data.fmstatus) {
                        alert(res.data);
                    } else if (res.data.fmstatus.code == "2") {
                        alert(res.data.fmstatus.errmsg);
                        this.loading=false
                    } else if (res.data.fmstatus.code == "3") {
                        // alert(res.data.fmstatus.errmsg);
                        this.$router.push({
                            name: "login",
                        });
                    } else {
                        this.show_hint2=res.data.ret.addappointuser_hint
                        this.fileList2 = res.data.ret.datalist;
                    }
                })
               
        },
        // 渲染4
        getFileList_alias() {
            this.loading = true;

            let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
          

            this.$axios
                .get("/api/adm/cgi/newspam.cgi", {
                    params: {
                        __mode: "list_alias_user",
                        sid: sid,
                    },
                })
                .then((res) => {
                    // console.log(res);
            this.loading = false;

                   if(!res){
             this.loading = false;
          }     
         else  if (!res.data.fmstatus) {
                        alert(res.data);
                    } else if (res.data.fmstatus.code == "2") {
                        alert(res.data.fmstatus.errmsg);
                        this.loading=false
                    } else if (res.data.fmstatus.code == "3") {
                        // alert(res.data.fmstatus.errmsg);
                        this.$router.push({
                            name: "login",
                        });
                    } else {
                        this.fileList3 = res.data.ret.datalist;
                        this.show_hint3=res.data.ret.addaaliasuser_hint
                        
                    }
                })
               
        },
        handleClick_edit(index, scope) {
            console.log(index, scope);
            this.email=scope.EMAIL;
            this.notice_time=scope.NOTICE_TIME;
            this.notific_policy=scope.TYPE;
                this.newadd=0;
                this.custom_editing=0;
               this.tanchu=true;
        },
         //自定义列表保存
        save4() {
            this.$save_hint_test();
            this.$disable_hint_test();
            let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
            console.log(sid);

          

            // console.log(col, '5555')

            this.$axios
                .get("/api/adm/cgi/bspam.cgi", {
                    params: {
                        __mode: "save_custom_isolation",
                        sid: sid,
                        email: this.email,
                        notice_time: this.notice_time,
                        type: this.notific_policy,
                        newadd:this.newadd,

                    },
                })
                .then((res) => {
                    console.log(res);
this.$close_hint_test();
this.$close_disable_hint_test();
                    if (!res.data.fmstatus) {
                        alert(res.data);
                    } else if (res.data.fmstatus.code == "1") {
                        alert(res.data.fmstatus.errmsg);
                    } else if (res.data.fmstatus.code == "2") {
                        alert(res.data.fmstatus.errmsg);
                        
                    } else if (res.data.fmstatus.code == "3") {
                        // alert(res.data.fmstatus.errmsg);
                        this.$router.push({
                            name: "login",
                        });
                    } else {
                        this.tanchu = false;
                        this.loading = false;
                        this.getFileList_notific();
                        this.$message({
                            type: "success",
                            message: `${this.$t("anti_gs1_tan.save_sueecss")}`,
                        });
                    }
                });
        },
          // 自定义
        getFileList_notific() {
            this.loading = true;

            let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
        

            this.$axios
                .get("/api/adm/cgi/bspam.cgi", {
                    params: {
                        __mode: "load_custom_isolation",
                        sid: sid,
                    },
                })
                .then((res) => {
                    console.log(res);
             this.loading = false;

                   if(!res){
             this.loading = false;
          }     
         else  if (!res.data.fmstatus) {
                        alert(res.data);
                    } else if (res.data.fmstatus.code == "2") {
                        alert(res.data.fmstatus.errmsg);
                        this.loading=false
                    } else if (res.data.fmstatus.code == "3") {
                        // alert(res.data.fmstatus.errmsg);
                        this.$router.push({
                            name: "login",
                        });
                    } else {
                        this.fileList4 = res.data.ret.datalist;
                        this.show_hint4=res.data.ret.addaaliasuser_hint;
                        this.notific_policy_arr=res.data.ret.q_notify_type;
                        
                    }
                })
               
        },
        // 删除1
        handleClick1(index, scope) {
            console.log(index, scope);
            this.$confirm(`${this.$t("anti_gs1_tan.del")}`, {
                    confirmButtonText: `${this.$t("tan.confirm")}`,
                    cancelButtonText: `${this.$t("tan.cancel")}`,
                    type: "warning",
                })
                .then(() => {
                    let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
                    let excludeuser = scope.DNOREMAIL;

                    this.$axios
                        .get("/api/adm/cgi/newspam.cgi", {
                            params: {
                                __mode: "del_excludeuser",
                                sid: sid,
                                excludeuser: excludeuser,

                            },
                        })
                        .then((res) => {
                            console.log(res);

                            if (!res.data.fmstatus) {
                                alert(res.data);
                            } else if (res.data.fmstatus.code == "1") {
                                alert(res.data.fmstatus.errmsg);
                            } else if (res.data.fmstatus.code == "2") {
                                alert(res.data.fmstatus.errmsg);
                                
                            } else if (res.data.fmstatus.code == "3") {
                                alert(res.data.fmstatus.errmsg);
                                this.$router.push({
                                    name: "login",
                                });
                            } else {
                               
                                this.getFileList_exclude();
                                this.$message({
                                    type: "success",
                                    message: `${this.$t("anti_gs1_tan.del1")}`,
                                });
                            }
                        });
                })
                .catch(() => {
                    this.$message({
                        type: "info",
                        message: `${this.$t("anti_gs1_tan.del2")}`,
                    });
                });
        },
        // 删除2
        handleClick2(index, scope) {
            console.log(index, scope);
            this.$confirm(`${this.$t("anti_gs1_tan.del")}`, {
                    confirmButtonText: `${this.$t("tan.confirm")}`,
                    cancelButtonText: `${this.$t("tan.cancel")}`,
                    type: "warning",
                })
                .then(() => {
                    let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
                    let excludeuser = scope.DNOREMAIL;

                    this.$axios
                        .get("/api/adm/cgi/newspam.cgi", {
                            params: {
                                __mode: "del_appointuser",
                                sid: sid,
                                appointuser: excludeuser,

                            },
                        })
                        .then((res) => {
                            console.log(res);

                            if (!res.data.fmstatus) {
                                alert(res.data);
                            } else if (res.data.fmstatus.code == "1") {
                                alert(res.data.fmstatus.errmsg);
                            } else if (res.data.fmstatus.code == "2") {
                                alert(res.data.fmstatus.errmsg);
                                
                            } else if (res.data.fmstatus.code == "3") {
                                alert(res.data.fmstatus.errmsg);
                                this.$router.push({
                                    name: "login",
                                });
                            } else {
                               
                                this.getFileList_assign ();
                                this.$message({
                                    type: "success",
                                    message: `${this.$t("anti_gs1_tan.del1")}`,
                                });
                            }
                        });
                })
                .catch(() => {
                    this.$message({
                        type: "info",
                        message: `${this.$t("anti_gs1_tan.del2")}`,
                    });
                });
        },
        // 删除3
        handleClick3(index, scope) {
            console.log(index, scope);
            this.$confirm(`${this.$t("anti_gs1_tan.del")}`, {
                    confirmButtonText: `${this.$t("tan.confirm")}`,
                    cancelButtonText: `${this.$t("tan.cancel")}`,
                    type: "warning",
                })
                .then(() => {
                    let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
                    let excludeuser = scope.EMAIL;

                    this.$axios
                        .get("/api/adm/cgi/newspam.cgi", {
                            params: {
                                __mode: "del_aliasuser",
                                sid: sid,
                                aliasuser: excludeuser,

                            },
                        })
                        .then((res) => {
                            console.log(res);

                            if (!res.data.fmstatus) {
                                alert(res.data);
                            } else if (res.data.fmstatus.code == "1") {
                                alert(res.data.fmstatus.errmsg);
                            } else if (res.data.fmstatus.code == "2") {
                                alert(res.data.fmstatus.errmsg);
                               
                            } else if (res.data.fmstatus.code == "3") {
                                alert(res.data.fmstatus.errmsg);
                                this.$router.push({
                                    name: "login",
                                });
                            } else {
                               
                                this.getFileList_alias();
                                this.$message({
                                    type: "success",
                                    message: `${this.$t("anti_gs1_tan.del1")}`,
                                });
                            }
                        });
                })
                .catch(() => {
                    this.$message({
                        type: "info",
                        message: `${this.$t("anti_gs1_tan.del2")}`,
                    });
                });
        },
         // 删除4 自定义
        handleClick4(index, scope) {
            console.log(index, scope);
            this.$confirm(`${this.$t("anti_gs1_tan.del")}`, {
                    confirmButtonText: `${this.$t("tan.confirm")}`,
                    cancelButtonText: `${this.$t("tan.cancel")}`,
                    type: "warning",
                })
                .then(() => {
                    let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
                    let excludeuser = scope.EMAIL;

                    this.$axios
                        .get("/api/adm/cgi/bspam.cgi", {
                            params: {
                                __mode: "del_custom_isolation",
                                sid: sid,
                                email: excludeuser,

                            },
                        })
                        .then((res) => {
                            console.log(res);

                            if (!res.data.fmstatus) {
                                alert(res.data);
                            } else if (res.data.fmstatus.code == "1") {
                                alert(res.data.fmstatus.errmsg);
                            } else if (res.data.fmstatus.code == "2") {
                                alert(res.data.fmstatus.errmsg);
                               
                            } else if (res.data.fmstatus.code == "3") {
                                alert(res.data.fmstatus.errmsg);
                                this.$router.push({
                                    name: "login",
                                });
                            } else {
                              
                                this.getFileList_notific();
                                this.$message({
                                    type: "success",
                                    message: `${this.$t("anti_gs1_tan.del1")}`,
                                });
                            }
                        });
                })
                .catch(() => {
                    this.$message({
                        type: "info",
                        message: `${this.$t("anti_gs1_tan.del2")}`,
                    });
                });
        },
        // 显示
        tan: function () {
            this.tanchu = true;
            this.dnoremail='';
            this.email='';
            this.alias='';
            this.notice_time=""
            this.notific_policy=""
            this.newadd=1;
              this.custom_editing=1;
            
        },
        // 打开关闭
        tanSend: function () {
            this.tanchu = false;
        },
        tanOff: function () {
            this.tanchu = false;
        },
    },
};
</script>

<style lang="less" scoped>









@import "../../css/table.less";
@import "../../css/lie_td.less";
@import "../../css/pou_up.less";
@import "../../css/drag.less";
.lie tbody tr td div:nth-child(2) {
   
        margin-top: 0;
   
}
</style>
